/**
 * Étapes (`step`) qui identifient une ligne de contrat PRINCIPAL (par opposition à un avenant).
 * Côté serveur, les avenants sont créés avec `step = "Avenant N"` (ou legacy `"Prolongation N"`),
 * tandis que le contrat principal porte `"Contrat principal"` ou `"CGV"`.
 */
export const MAIN_CONTRACT_STEPS = ['Contrat principal', 'CGV'] as const;

/**
 * Vrai si le `step` correspond à une ligne de contrat principal (et non à un avenant).
 * Centralise la règle historiquement dupliquée (`missions.ts`, frontend `LegalContractFile`).
 */
export const isMainContractStep = (step?: string | null): boolean =>
  MAIN_CONTRACT_STEPS.includes((step ?? '') as (typeof MAIN_CONTRACT_STEPS)[number]);
